import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'ecp-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.css']
})
export class ToolBarComponent implements OnInit {

    @Input() customX;
    @Input() customY;
    @Input() ecpStyle: object = {};
    //@Input() customLocation: any={'x': '100px', 'y': '50px'};
    @Output() selectId: EventEmitter<string> = new EventEmitter();

    click(url) {
        this.selectId.emit(url);
    }

    /*
      menuJSON = [{
        "name": "æ·»å åç´ ",
        "url": "http://www.google.com",
        "chird": [
          {
            "name": "åæ ",
            "url": "http://www.google.com"
          },
          {
            "name": "ä¼ æå¨",
            "url": "http://www.baidu.com"
          },
          {
            "name": "ç®¡é",
            "url": "http://www.SoSo.com"
          },
          {
            "name": "èç¹",
            "url": "http://www.SoSo.com"
          },
          {
            "name": "å µå¤´å°æ¿",
            "url": "http://www.SoSo.com"
          },
          {
            "name": "é¸é",
            "url": "http://www.SoSo.com"
          },
          {
            "name": "æ¶é²æ ",
            "url": "http://www.SoSo.com"
          }
        ]
      }, {
        "name": "ç­æ¥",
        "url": "http://www.google.com",
        "chird": null
      }, {
        "name": "é¢è­¦",
        "url": "http://www.google.com",
        "chird": [
          {
            "name": "åæ ",
            "url": "http://www.google.com"
          },
          {
            "name": "ä¼ æå¨",
            "url": "http://www.baidu.com"
          },
          {
            "name": "ç®¡é",
            "url": "http://www.SoSo.com"
          }
        ]
      }, {
        "name": "çç®¡åæ",
        "url": "http://www.google.com",
        "chird": null
      }, {
        "name": "éé¨åæ",
        "url": "http://www.google.com",
        "chird": null
      }];*/

    menuJSON = [{
        'name': 'æ·»å åç´ ',
        'url': 'http://www.google.com',
        'chird': [
            {
                'name': 'åæ ',
                'url': 'add_point'
            },
            {
                'name': 'ä¼ æå¨',
                'url': 'add_sensor'
            },
            {
                'name': 'ç®¡é',
                'url': 'add_pipe'
            },
            {
                'name': 'èç¹',
                'url': 'add_node'
            },
            {
                'name': 'å µå¤´å°æ¿',
                'url': 'add_plug'
            },
            {
                'name': 'é¸é',
                'url': 'add_valve'
            },
            {
                'name': 'æ¶é²æ ',
                'url': 'add_hydrant'
            }
        ]
    }, {
        'name': 'ç­æ¥',
        'url': 'screening',
        'chird': null
    }, {
        'name': 'é¢è­¦',
        'url': 'http://www.google.com',
        'chird': [
            {
                'name': 'å®æ¶æµéæ¾ç¤º',
                'url': 'http://www.google.com',
                'isSwitch': true
            },
            {
                'name': 'ååºç¨æ°´éåæ',
                'url': 'http://www.baidu.com'
            }
        ]
    }, {
        'name': 'çç®¡åæ',
        'url': 'analysis_pipe',
        'chird': null
    }, {
        'name': 'éé¨åæ',
        'url': 'analysis_valve',
        'chird': null
    }];

    hoverId: number = 0; // å½åå·²éä¸­
    thisMenuId: number = 0; // å½åéä¸­å­èå
    menuSel(i) {
        this.hoverId = i;
        this.thisMenuId = i;
    }

    showSubMenu(i) {
        this.hoverId = i;
        this.thisMenuId = i;
    }

    constructor() {
    }

    ngOnInit() {
        /*   if (this.customLocation == '') {
             this.customLocation = {'x': '0', 'y': '0'};
           }*/
        this.menuJSON.reverse();
    }

}
